import { setCookie, sendGoogleEvent } from '@html/_common/utils';

export default function initiateBookFlexibilityBanner(eventCategory) {
  const $section = $('.ao-tour-book-flexibility-banner');

  if ($section.length === 0) {
    return;
  }

  const $closeButton = $('.js-ao-tour-book-flexibility-banner__close');

  $closeButton.click(() => {
    $section.addClass('ao-tour-book-flexibility-banner--closed');

    setCookie({
      name: 'cfft_banner',
      value: '1',
      expires: 24 * 3600,
      path: '/',
    });

    sendGoogleEvent(
      eventCategory,
      'Book Flexibility Banner',
      'Click close',
    );
  });
}
